// Module
var code = "<section id=\"contact_horses_section\" class=\"content-area content-area--divider\"> <h3 class=\"primary-heading\">Notes</h3> <bm-rich-text-editor content=\"vm.contact.notes\"></bm-rich-text-editor> </section> <section></section> ";
// Exports
module.exports = code;